import React from "react";
import { Tag, Tooltip } from "antd";

const LEAD_UI = {
	ColdIdle: {
		color: "default",
		label: "Sin interaccion",
		hint: "1 solo mensaje o sin intención clara",
	},
	EngagedNoCart: {
		color: "geekblue",
		label: "Engaged (sin carrito)",
		hint: "Interaccion de mas de 2 mensajes y sin carrito",
	},
	CartStarted: {
		color: "blue",
		label: "Carrito iniciado",
		hint: "Tuvo actividad con carrito",
	},
	CartAbandonedHot: {
		color: "volcano",
		label: "Abandono reciente",
		hint: "Abandono reciente con intención alta",
	},
	CartAbandonedCold: {
		color: "orange",
		label: "Abandono viejo",
		hint: "Abandono viejo o sin señales fuertes",
	},
	Converted: { color: "green", label: "Convertido", hint: "Terminó en pedido" },
	Closed: {
		color: "default",
		label: "Cerrado",
		hint: "Cierre manual / ticket / fuera de ciclo",
	},
};

export default function LeadStatusTag({ status, reason, withTooltip = true }) {
	if (!status) return <Tag>—</Tag>;

	const cfg = LEAD_UI[status] || { color: "blue", label: status, hint: "" };

	const content = <Tag color={cfg.color}>{cfg.label}</Tag>;

	if (!withTooltip) return content;

	return (
		<Tooltip
			title={
				<div style={{ maxWidth: 280 }}>
					<div style={{ fontWeight: 600 }}>{cfg.hint || cfg.label}</div>
					{/* {reason ? (
						<div style={{ opacity: 0.85 }}>Motivo: {reason}</div>
					) : null} */}
				</div>
			}
		>
			{content}
		</Tooltip>
	);
}
